import {
  NO_CONTENT,
  BAD_REQUEST,
  ERROR_MESSAGE_INVALID_EMAIL,
  ERROR_MESSAGE_INVALID_MESSAGE,
  ERROR_MESSAGE_EMAIL_NOT_SENT,
} from 'shared/constants';
import { isValidEmail, isValidMessage } from 'shared/validations';

const contactAction = async ({ request }) => {
  const formData = await request.formData();
  const email = formData.get('email');
  const name = formData.get('name');
  const message = formData.get('message');
  const errors = {};

  if (!isValidEmail(email)) {
    errors.email = ERROR_MESSAGE_INVALID_EMAIL;
  }

  if (!isValidMessage(message)) {
    errors.message = ERROR_MESSAGE_INVALID_MESSAGE;
  }

  if (Object.keys(errors).length > 0) {
    return { errors };
  }

  return fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, name, message }),
  }).then(async (response) => {
    if (response.status === NO_CONTENT) {
      return { success: true };
    }

    if (response.status === BAD_REQUEST) {
      const result = await response?.json();
      return { errors: result.errors };
    }

    return { errors: { serverError: ERROR_MESSAGE_EMAIL_NOT_SENT } };
  }).catch(() => ({ errors: { serverError: ERROR_MESSAGE_EMAIL_NOT_SENT } }));
};

export {
  contactAction,
};
